import _ from 'lodash'
import moment from 'moment'
import React from 'react'

import http from '../../../lib/http'
import { AutoComplete } from '../NarusMaterial'

import { makeAutobindedInput } from './FormBuilder'

const textFunc = obj =>
  (obj && _.join(_.compact([ obj.lastName, obj.firstName ]), ', ')) || ''

const displayFunc = obj => {
  if (obj) {
    const now = moment()
    const coverage = (obj.coverage || [])
      .map(c => {
        if (c.end) {
          const milliseconds = Date.parse(c.end)
          if (milliseconds) {
            return _.merge(c, {
              end: moment(new Date(milliseconds))
            })
          }
        }
        return c
      })
      .filter(c => !c.end || c.end >= now)
      .map(
        c =>
          `${c.name} - ${c.relationship}${
            (c.end && ` (${c.end.format('MM/DD/YYYY')})`) || ''
          }`
      )
      .join(', ')
    let { birthDate } = obj

    if (birthDate) {
      const milliseconds = Date.parse(birthDate)
      if (milliseconds) {
        birthDate = moment(new Date(milliseconds)).format('MM/DD/YYYY')
      }
    }

    return _.join(
      _.compact([ obj.lastName, obj.firstName, birthDate, coverage ]),
      ', '
    )
  }
  return ''
}
class _PatientSelect extends React.Component {
  constructor (props) {
    super(props)
    this.dataFunc = this.dataFunc.bind(this)
    this.handle = this.handle.bind(this)
  }

  dataFunc (text) {
    const { clientName, filter: propFilter } = this.props
    if (text && text.length > 0) {
      return new Promise(resolve => {
        const search = {
          anyName: text,
          scope: 'all',
          status: 'all',
          managingOrg: 'all',
          sortBy: 'lastName',
          sortDir: 'asc',
          coverage: true,
          count: 50
        }
        http
          .getRequest('/patients_search', search, { clientName })
          .then(response => {
            const { data: rows } = response
            if (!rows || rows.length === 0) {
              resolve('Sorry, no results found.')
            } else {
              const filter = propFilter || (() => true)
              const data = rows.filter(filter)

              if (data.length > 0) {
                resolve(data)
              } else {
                resolve('Sorry, no results found.')
              }
            }
          })
          .catch(() => {
            resolve('Sorry, could not make a search. Error occurred.')
          })
      })
    }
    return Promise.resolve('Please enter search criteria for Patients')
  }

  handle (v) {
    const { onChange } = this.props
    if (onChange && typeof v !== 'function') {
      onChange(v)
    }
  }

  render () {
    const { label, value } = this.props
    return (
      <AutoComplete
        label={label}
        dataFunc={this.dataFunc}
        textFunc={textFunc}
        displayFunc={displayFunc}
        value={value || ''}
        onChange={this.handle}
      />
    )
  }
}

export const PatientSelect = makeAutobindedInput(_PatientSelect)
